import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../../../services/admin.service';
import { PageEvent } from '@angular/material/paginator';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-processed',
  templateUrl: './processed.component.html',
  styleUrls: ['./processed.component.scss']
})
export class ProcessedComponent implements OnInit {
  jobs = [];
  page = null;
  pageEvent: PageEvent;
  filter = null;

  filterOptions = [
    { name: 'exportMasterDataReportJob', displayName: 'Stammdaten Report'},
    { name: 'requestNewCardsToHouseholdsJob', displayName: 'Kundenkarten'},
    { name: 'importNewsItemJob', displayName: 'News'},
    { name: 'synchronizeBasicCustomerJob', displayName: 'Kunden'},
    { name: 'validateBasicContractJob', displayName: 'Verträge'},
    { name: 'validateBasicCustomerJob', displayName: 'Kundenvalidierung'},
  ];

  constructor(private adminService: AdminService) { }

  ngOnInit() {
    this.getBatchJobs(0,24);
  }

  loadPage(event?: PageEvent) {
    console.log(event)
    this.getBatchJobs(event.pageIndex,event.pageSize);
  }

  getBatchJobs(page,size) {
    this.adminService.getBatchStatus(page,size).subscribe(res => {
      this.jobs = res.content;
      this.page = res.page;
    });
  }
  
  downloadFile(filePath) {
    this.adminService.downloadBatchFile(filePath);
  }

  filterData() {
    console.log('filter by: ', this.filter);
    if (!this.filter) {
      this.getBatchJobs(0,24);
    } else {
      this.adminService.getBatchStatus(0, 1000).pipe(
        map(data => {         
          return data.filter(job => job.jobName == this.filter);
        })
      ).subscribe(res => {
        this.jobs = res;
      });
    }
  }
}
